// Vite environment variable compatibility shim
// This file provides process.env compatibility for code that uses REACT_APP_* variables
// Runtime environment variables are loaded via runtime-envs.js in public folder

// Polyfill process if it doesn't exist (e.g., in browser)
if (typeof window !== 'undefined' && (typeof process === 'undefined' || !process.env)) {
  (window as any).process = {
    env: {
      NODE_ENV: import.meta.env.MODE || 'development',
    },
  };
}

// Map import.meta.env to process.env for backwards compatibility
// This allows existing code using process.env.REACT_APP_* to continue working
if (typeof process !== 'undefined' && process.env && import.meta.env) {
  // Copy all env vars from import.meta.env to process.env
  Object.keys(import.meta.env).forEach((key) => {
    if (key.startsWith('REACT_APP_') || key.startsWith('VITE_')) {
      const reactKey = key.startsWith('VITE_')
        ? key.replace(/^VITE_/, 'REACT_APP_')
        : key;
      if (!process.env[reactKey]) {
        process.env[reactKey] = import.meta.env[key];
      }
    }
  });

  // Ensure NODE_ENV is set
  if (!process.env.NODE_ENV) {
    process.env.NODE_ENV = import.meta.env.MODE || 'development';
  }
}

// Note: Runtime environment variables loaded from runtime-envs.js will
// override these values when the script runs, which is the desired behavior

